import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  DirectionsServiceEnum,
  formatRebuildRouteResetToProviderLabel,
  formatRebuildRouteSystemDefaultLabel,
  isLastUsedRouteProviderDifferentFromSystem,
} from "@ryde/shared";

interface IRebuildRouteDropdownDefaultActionSystemDefaultResetProps {
  lastUsedProvider?: DirectionsServiceEnum | null;
  systemDefaultProvider: DirectionsServiceEnum;
  isLoading?: boolean;
  onResetToSystemDefault: () => void;
}

export const RebuildRouteDropdownDefaultActionSystemDefaultReset: FC<
  IRebuildRouteDropdownDefaultActionSystemDefaultResetProps
> = ({
  lastUsedProvider,
  systemDefaultProvider,
  isLoading,
  onResetToSystemDefault,
}) => {
  const { t } = useTranslation();

  const showProviderMismatch = useMemo(
    () =>
      isLastUsedRouteProviderDifferentFromSystem({
        lastUsedProvider,
        systemDefaultProvider,
      }),
    [lastUsedProvider, systemDefaultProvider],
  );

  if (!showProviderMismatch || !lastUsedProvider) {
    return null;
  }

  return (
    <div className="rebuild-route-dropdown-default-provider-row rebuild-route-dropdown-default-provider-row--after-submit">
      <span className="rebuild-route-dropdown-settings rebuild-route-dropdown-settings--inline">
        {formatRebuildRouteSystemDefaultLabel({
          provider: systemDefaultProvider,
          t,
        })}
      </span>

      <button
        type="button"
        className="rebuild-route-dropdown-reset-badge"
        data-e2e="rebuild-route-reset-to-system-default"
        disabled={isLoading}
        onClick={onResetToSystemDefault}
      >
        {formatRebuildRouteResetToProviderLabel({
          provider: systemDefaultProvider,
          t,
        })}
      </button>
    </div>
  );
};
